<template>
    <div class="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200">
        <div class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap px-4 py-5 sm:p-6">
            <div class="ml-4 mt-2">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Listing</h3>
            </div>
        </div>
    
        <div class="px-4 py-5 sm:p-6">

            <Fieldset heading="Log Book & Keys">
                <FormField :field="state.suppliment_form.fields.v5c_vendor_status" namespace="grade" :name="'v5c_vendor_status'" class="mb-4" />
                <FormField :field="state.suppliment_form.fields.v5c_auctioneer_status" namespace="grade" :name="'v5c_auctioneer_status'" class="mb-4" />
                <FormField :field="state.suppliment_form.fields.keys_vendor_status" namespace="grade" :name="'keys_vendor_status'" class="mb-4" />
                <FormField :field="state.suppliment_form.fields.keys_vendor_notes" namespace="grade" :name="'keys_vendor_notes'" class="mb-4" />
                <FormField :field="state.suppliment_form.fields.keys_auctioneer_status" namespace="grade" :name="'keys_auctioneer_status'" class="mb-4" />
                <FormField :field="state.suppliment_form.fields.keys_auctioneer_notes" namespace="grade" :name="'keys_auctioneer_notes'" class="mb-4" />
            </Fieldset>

            <Fieldset heading="Service History">
                <FormField :field="state.suppliment_form.fields.service_history_vendor_status" namespace="grade" :name="'service_history_vendor_status'" class="mb-4" />
                <AssetFileUpload v-if="user_is_seller && state.suppliment_form.fields.service_history_vendor_status.value == 'provided'" :asset_id="vehicle_asset_id" field_id="vehicle-file-uploader" asset_type="vehicle" :media_type="'service-history'" :base_file_name="''" />
                <FormField :field="state.suppliment_form.fields.service_history_main_dealer_count" namespace="grade" :name="'service_history_main_dealer_count'" class="mb-4" />
                <FormField :field="state.suppliment_form.fields.service_history_other_count" namespace="grade" :name="'service_history_other_count'" class="mb-4" />
                <FormField :field="state.suppliment_form.fields.service_history_last_service_date" namespace="grade" :name="'service_history_last_service_date'" class="mb-4" />
                <FormField :field="state.suppliment_form.fields.service_history_last_service_mileage" namespace="grade" :name="'service_history_last_service_mileage'" class="mb-4" />
                <FormField :field="state.suppliment_form.fields.service_history_vendor_notes" namespace="grade" :name="'service_history_vendor_notes'" class="mb-4" />
                <FormField :field="state.suppliment_form.fields.service_history_auctioneer_notes" namespace="grade" :name="'service_history_auctioneer_notes'" class="mb-4" />
            </Fieldset>

            <Fieldset heading="Grade">
                <FormField namespace="grade" :name="'dealer_grade'" :field="state.grade_form.fields.dealer_grade" class="mb-4" />
                <FormField namespace="grade" name="auctioneer_grade" :field="state.grade_form.fields.auctioneer_grade" class="mb-4" />
                <FormField namespace="grade" name="auctioneer_grade_notes" :field="state.grade_form.fields.auctioneer_grade_notes" class="mb-4" />
                <FormField namespace="grade" name="declared_faults" :field="state.grade_form.fields.declared_faults" />
            </Fieldset>

        </div>
        <div class="px-4 py-4 sm:px-6 text-right">
            <Button type="button" width="w-auto" color="blue-outline" :onClick="VEHICLE.activatePrevStep">Back</Button>
            <Button type="button" width="w-auto" class="ml-2" :onClick="() => submitStep()" :disabled="!next_button_active">Next</Button>
        </div>
    </div>
</template>

<script>
import { useVehicleStore } from '@sto/vehicle.store'
import { useSystemStore } from '@sto/system.store'
import { useAuthStore } from '@sto/auth.store'
import { useUserStore } from '@sto/user.store'
import * as AssetService from '@ser/asset'
import { computed, onMounted, onBeforeMount, reactive, watch } from 'vue'
import LoadingIcon from '@ico/LoadingIcon.vue'
import { isValid, getPayload, getUserOrganisationType } from '@lib/helpers'
import { useRoute } from 'vue-router'
import config from '@/config'

import AssetFileUpload from '@par/asset/AssetFileUpload.vue'
import Fieldset from "@glo/Fieldset.vue";
import FormField from "@glo/FormField.vue";

export default {
    components: {
        FormField,
        Fieldset,
        LoadingIcon,
        AssetFileUpload
    },
    setup() {
        const VEHICLE = useVehicleStore()
        const ROUTE = useRoute()
        const SYSTEM_STORE = useSystemStore()
        const AUTH_STORE = useAuthStore()
        const USER_STORE = useUserStore()

        const vehicle_id = computed(() => {
            return VEHICLE?.vehicle?.id || null
        })

        const vehicle_data = computed(() => {
            return VEHICLE?.vehicle || null
        })

        const vehicle_asset_id = computed(() => {
            return VEHICLE?.vehicle?.asset?.id || null
        })

        const user_is_seller = computed(() => {
            const asset_seller_account_id = VEHICLE?.vehicle?.asset?.seller_account_id ? VEHICLE?.vehicle?.asset.seller_account_id
                : VEHICLE?.vehicle?.asset?.seller_account?.id ? VEHICLE?.vehicle?.asset.seller_account.id
                : VEHICLE?.vehicle?.asset?.seller?.account_id ? VEHICLE?.vehicle?.asset.seller.account_id
                : null

            return asset_seller_account_id ? USER_STORE.userIsSellerOfAsset({asset_seller_account_id: asset_seller_account_id})
                : false
        })

        const user_is_auctioneer = computed(() => {
            const asset_auctioneer_id = VEHICLE?.vehicle?.asset?.auctioneer_id ? VEHICLE?.vehicle?.asset?.auctioneer_id
                : VEHICLE?.vehicle?.asset?.auctioneer?.id ? VEHICLE?.vehicle?.asset?.auctioneer?.id
                : null

            return asset_auctioneer_id ? USER_STORE.userIsAuctioneerOfAsset({asset_auctioneer_id: asset_auctioneer_id})
                : false
        })

        const next_button_active = computed(() => {

            let active = true

            for (let f in state.grade_form.fields) {
                if (state.grade_form.fields[f].required && !state.grade_form.fields[f].value) active = false
            }

            return active
        })

        const state = reactive({
            grade_form: {
                valid: false,
                has_changes: computed(() => {
                    let has_changes = false
                    for (let f in state.grade_form.fields) {
                        if (state.grade_form.fields[f].value != state.grade_form.fields[f].stored_value) has_changes = true
                    }
                    return has_changes
                }),
                loading: false,
                fields: {
                    dealer_grade: {
                        active: user_is_seller.value,
                        label: 'Please enter you own grade if you have one',
                        type: 'select',
                        value: vehicle_data?.value?.asset?.dealer_grade || '',
                        stored_value: vehicle_data?.value?.asset?.dealer_grade || '',
                        options: [
                            {
                                value: '',
                                label: 'Please choose...'
                            },
                            {
                                value: '1',
                                label: '1'
                            },
                            {
                                value: '2',
                                label: '2'
                            },
                            {
                                value: '3',
                                label: '3'
                            },
                            {
                                value: '4',
                                label: '4'
                            },
                            {
                                value: '5',
                                label: '5'
                            }
                        ],
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    auctioneer_grade: {
                        active: user_is_auctioneer.value,
                        label: 'Grade',
                        type: 'select',
                        value: vehicle_data?.value?.asset?.auctioneer_grade || '',
                        stored_value: vehicle_data?.value?.asset?.auctioneer_grade || '',
                        options: [
                            {
                                value: '',
                                label: 'Please choose...'
                            },
                            {
                                value: '',
                                label: 'Please choose...'
                            },
                            {
                                value: '1',
                                label: '1'
                            },
                            {
                                value: '1.5',
                                label: '1.5'
                            },
                            {
                                value: '2',
                                label: '2'
                            },
                            {
                                value: '2.5',
                                label: '2.5'
                            },
                            {
                                value: '3',
                                label: '3'
                            },
                            {
                                value: '3.5',
                                label: '3.5'
                            },
                            {
                                value: '4',
                                label: '4'
                            },
                            {
                                value: '4.5',
                                label: '4.5'
                            },
                            {
                                value: '5',
                                label: '5'
                            },
                            {
                                value: '1 (Trade)',
                                label: '1 (Trade)'
                            },
                            {
                                value: '1.5 (Trade)',
                                label: '1.5 (Trade)'
                            },
                            {
                                value: '2 (Trade)',
                                label: '2 (Trade)'
                            },
                            {
                                value: '2.5 (Trade)',
                                label: '2.5 (Trade)'
                            },
                            {
                                value: '3 (Trade)',
                                label: '3 (Trade)'
                            },
                            {
                                value: '3.5 (Trade)',
                                label: '3.5 (Trade)'
                            },
                            {
                                value: '4 (Trade)',
                                label: '4 (Trade)'
                            },
                            {
                                value: '4.5 (Trade)',
                                label: '4.5 (Trade)'
                            },
                            {
                                value: '5 (Trade)',
                                label: '5 (Trade)'
                            },
                            {
                                value: 'Classic',
                                label: 'Classic'
                            },
                            {
                                value: 'Unclassified',
                                label: 'Unclassified'
                            }
                        ],
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    auctioneer_grade_notes: {
                        active: user_is_auctioneer.value,
                        label: 'Grade notes',
                        type: 'richtext',
                        value: vehicle_data?.value?.asset.auctioneer_grade_notes || '',
                        stored_value: vehicle_data?.value?.asset.auctioneer_grade_notes || '',
                        richtext_options: {
                            formatting: ['bold', 'italic', 'ul']
                        },
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    declared_faults: {
                        active: user_is_auctioneer.value,
                        label: 'Declared faults',
                        type: 'richtext',
                        richtext_options: {
                            formatting: ['bold', 'italic', 'ul']
                        },
                        value: vehicle_data?.value?.asset.declared_faults || '',
                        stored_value: vehicle_data?.value?.asset.declared_faults || '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                }
            },
            suppliment_form: {
                valid: false,
                has_changes: computed(() => {
                    let has_changes = false
                    for (let f in state.suppliment_form.fields) {
                        if (state.suppliment_form.fields[f].value != state.suppliment_form.fields[f].stored_value) has_changes = true
                    }
                    return has_changes
                }),
                loading: false,
                fields: {
                    v5c_vendor_status: {
                        active: user_is_seller.value,
                        label: 'V5C',
                        type: 'select',
                        value: vehicle_data?.value?.v5c_vendor_status || '',
                        stored_value: vehicle_data?.value?.v5c_vendor_status || '',
                        options: [
                            {
                                value: '',
                                label: 'Please choose...'
                            },
                            {
                                value: 'none',
                                label: 'None'
                            },
                            {
                                value: 'original_to_follow',
                                label: 'To follow'
                            },
                            {
                                value: 'has_copy_no_original',
                                label: 'Copy (Original not available)'
                            },
                            {
                                value: 'has_copy_original_to_follow',
                                label: 'Copy (Original to follow)'
                            },
                            {
                                value: 'has_original',
                                label: 'Original'
                            }
                        ],
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    v5c_auctioneer_status: {
                        active: user_is_auctioneer.value,
                        label: 'V5C',
                        type: 'select',
                        value: vehicle_data?.value?.v5c_auctioneer_status || '',
                        stored_value: vehicle_data?.value?.v5c_auctioneer_status || '',
                        options: [
                            {
                                value: '',
                                label: 'Please choose...'
                            },
                            {
                                value: 'none',
                                label: 'Not in possession'
                            },
                            {
                                value: 'has_copy',
                                label: 'In possession of copy'
                            },
                            {
                                value: 'has_original',
                                label: 'In possession of original'
                            }
                        ],
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    keys_vendor_status: {
                        active: user_is_seller.value,
                        label: 'Keys',
                        type: 'select',
                        value: vehicle_data?.value?.keys_vendor_status || '',
                        stored_value: vehicle_data?.value?.keys_vendor_status || '',
                        options: [
                            {
                                value: '',
                                label: 'Please choose...'
                            },
                            {
                                value: 'none',
                                label: 'None'
                            },
                            {
                                value: 'one',
                                label: 'One'
                            },
                            {
                                value: 'two',
                                label: 'Two'
                            },
                            {
                                value: 'other',
                                label: 'Other'
                            },
                        ],
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    keys_vendor_notes: {
                        active: user_is_seller.value && vehicle_data?.value?.keys_vendor_status == 'other',
                        label: 'Key notes',
                        type: 'textarea',
                        value: vehicle_data?.value?.keys_vendor_notes || '',
                        stored_value: vehicle_data?.value?.keys_vendor_notes || '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    keys_auctioneer_status: {
                        active: user_is_auctioneer.value,
                        label: 'Keys',
                        type: 'select',
                        value: vehicle_data?.value?.keys_auctioneer_status || '',
                        stored_value: vehicle_data?.value?.keys_auctioneer_status || '',
                        options: [
                            {
                                value: '',
                                label: 'Please choose...'
                            },
                            {
                                value: 'none',
                                label: 'None'
                            },
                            {
                                value: 'one',
                                label: 'One'
                            },
                            {
                                value: 'two',
                                label: 'Two'
                            },
                            {
                                value: 'other',
                                label: 'Other'
                            },
                        ],
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    keys_auctioneer_notes: {
                        active: user_is_auctioneer.value && vehicle_data?.value?.keys_auctioneer_status == 'other',
                        label: 'Key notes',
                        type: 'textarea',
                        value: vehicle_data?.value?.keys_auctioneer_notes || '',
                        stored_value: vehicle_data?.value?.keys_auctioneer_notes || '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    service_history_vendor_status: {
                        active: user_is_seller.value,
                        label: 'Service history',
                        type: 'select',
                        value: vehicle_data?.value?.service_history_vendor_status || '',
                        stored_value: vehicle_data?.value?.service_history_vendor_status || '',
                        options: [
                            {
                                value: '',
                                label: 'Please choose...'
                            },
                            {
                                value: 'none',
                                label: 'None'
                            },
                            {
                                value: 'to_follow',
                                label: 'To Follow'
                            },
                            {
                                value: 'provided',
                                label: 'Provided'
                            },
                        ],
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    service_history_auctioneer_status: {
                        active: user_is_auctioneer.value,
                        label: 'Service history',
                        type: 'select',
                        value: vehicle_data?.value?.service_history_auctioneer_status || '',
                        stored_value: vehicle_data?.value?.service_history_auctioneer_status || '',
                        options: [
                            {
                                value: '',
                                label: 'Please choose...'
                            },
                            {
                                value: 'none',
                                label: 'Not provided'
                            },
                            {
                                value: 'provided',
                                label: 'Provided'
                            },
                        ],
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    service_history_main_dealer_count: {
                        active: user_is_auctioneer.value,
                        label: 'Number of main dealer services',
                        type: 'number',
                        value: vehicle_data?.value?.service_history_main_dealer_count || '',
                        stored_value: vehicle_data?.value?.service_history_main_dealer_count || '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    service_history_other_count: {
                        active: user_is_auctioneer.value,
                        label: 'Number of other services',
                        type: 'number',
                        value: vehicle_data?.value?.service_history_other_count || '',
                        stored_value: vehicle_data?.value?.service_history_other_count || '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    service_history_last_service_date: {
                        active: user_is_auctioneer.value,
                        label: 'Last service date',
                        type: 'datepicker',
                        min_date: null,
                        time_enabled: false,
                        date_format: 'dd-MM-yyyy',
                        date_clearable: true,
                        value: vehicle_data?.value?.service_history_last_service_date || '',
                        stored_value: vehicle_data?.value?.service_history_last_service_date || '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    service_history_last_service_mileage: {
                        active: user_is_auctioneer.value,
                        label: 'Last service mileage',
                        type: 'number',
                        value: vehicle_data?.value?.service_history_last_service_mileage || '',
                        stored_value: vehicle_data?.value?.service_history_last_service_mileage || '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    service_history_vendor_notes: {
                        active: user_is_seller.value,
                        label: 'Service history notes',
                        type: 'richtext',
                        value: vehicle_data?.value?.service_history_vendor_notes || '',
                        stored_value: vehicle_data?.value?.service_history_vendor_notes || '',
                        richtext_options: {
                            formatting: ['bold', 'italic', 'ul']
                        },
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    service_history_auctioneer_notes: {
                        active: user_is_auctioneer.value,
                        label: 'Service history notes',
                        type: 'richtext',
                        value: vehicle_data?.value?.service_history_auctioneer_notes || '',
                        stored_value: vehicle_data?.value?.service_history_auctioneer_notes || '',
                        richtext_options: {
                            formatting: ['bold', 'italic', 'ul']
                        },
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                }
            },
        })

        watch(
            () => state.suppliment_form.fields.keys_vendor_status.value,
            (new_value, old_value) => {
                state.suppliment_form.fields.keys_vendor_notes.active = (user_is_seller.value && state.suppliment_form.fields.keys_vendor_status.value == 'other')
            }
        )

        watch(
            () => state.suppliment_form.fields.keys_auctioneer_status.value,
            (new_value, old_value) => {
                state.suppliment_form.fields.keys_auctioneer_notes.active = (user_is_auctioneer.value && state.suppliment_form.fields.keys_auctioneer_status.value == 'other')
            }
        )

        const submitStep = async () => {
            // fields will automatically create their own validation states
            if (state.grade_form.loading || !isValid(state.grade_form.fields) || !isValid(state.suppliment_form.fields)) return

            // if the value is present and unchaned, just skip to the next step
            if (!state.grade_form.has_changes && !state.suppliment_form.has_changes) {
                VEHICLE.activateNextStep()
                return
            }

            state.grade_form.loading = true

            try {

                const asset_payload = getPayload(state.grade_form.fields)
                const asset_update = await AssetService.update(vehicle_asset_id.value, asset_payload)

                const vehicle_payload = getPayload(state.suppliment_form.fields)
                const vehicle_update = await VEHICLE.update(VEHICLE.vehicle.id, vehicle_payload)

                VEHICLE.activateNextStep()
            } catch (error) {
                console.error('submitStep', error)
                // TODO handle error
            }

            state.grade_form.loading = false
        }

        onMounted(() => {
            
            SYSTEM_STORE.createInteraction('STEP_UPDATE', ROUTE.fullPath, 'Vehicle grade step', null)

            isValid(state.grade_form.fields)

        })

        return {
            ROUTE,
            VEHICLE,
            state,
            submitStep,
            next_button_active,
            vehicle_asset_id,
            user_is_auctioneer,
            user_is_seller
        }
    }
}

</script>